import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { DbtModels as DbtModelsInner } from "./DbtModels";

// Wrap DbtModels with DatatableContextProvider for the new filter bar pattern
const DbtModels = () => (
  <DatatableContextProvider>
    <DbtModelsInner />
  </DatatableContextProvider>
);

export { DbtModels };
export * from "./DbtModelsDetails";
